import React from 'react';

/**
 * Skeleton — a placeholder shaped like the content it stands in for, with a
 * slow sheen (still under reduced motion). `line` is a text row, `block` a
 * card or cell, `bubble` a chat message. Decorative: hidden from readers —
 * the surrounding region carries the busy state.
 */
export type SkeletonShape = 'block' | 'line' | 'bubble';

export interface SkeletonProps {
  shape?: SkeletonShape;
  /** CSS width (number = px). Lines default to 100%. */
  width?: number | string;
  /** CSS height (number = px). Defaults: line 10, block 48, bubble 40. */
  height?: number | string;
  /** Dark variant for navy chrome. */
  dark?: boolean;
  className?: string;
}

const RADIUS: Record<SkeletonShape, string> = { block: 'rounded-pill', line: 'rounded-round', bubble: 'rounded-[12px]' };
const HEIGHT: Record<SkeletonShape, number> = { block: 48, line: 10, bubble: 40 };

const LIGHT = 'linear-gradient(90deg,#ECEFF4 30%,#F6F8FB 50%,#ECEFF4 70%)';
const DARK = 'linear-gradient(90deg,#1E2A3F 30%,#2A3852 50%,#1E2A3F 70%)';

export const Skeleton: React.FC<SkeletonProps> = ({ shape = 'line', width, height, dark = false, className = '' }) => (
  <span
    aria-hidden="true"
    data-skeleton={shape}
    className={`block motion-safe:animate-sheen ${RADIUS[shape]} ${className}`}
    style={{
      width: width ?? '100%',
      height: height ?? HEIGHT[shape],
      backgroundImage: dark ? DARK : LIGHT,
      backgroundSize: '200% 100%',
    }}
  />
);

export default Skeleton;
